export const ADD_TO_REGISTRY = 'ADD_TO_REGISTRY';
export const ADDED_TO_REGISTRY = 'ADDED_TO_REGISTRY';
export const HIDE_PRODUCT_REGISTRIES = 'HIDE_PRODUCT_REGISTRIES';
export const HIDE_REGISTRIES_FROM_WISHLIST = 'HIDE_REGISTRIES_FROM_WISHLIST';
export const RESET_ADD_TO_REGISTRY = 'RESET_ADD_TO_REGISTRY';
export const SET_PRODUCT_REGISTRY_VERSION = 'SET_PRODUCT_REGISTRY_VERSION';
export const SHOW_PRODUCT_REGISTRIES = 'SHOW_PRODUCT_REGISTRIES';

export default {
    ADD_TO_REGISTRY,
    ADDED_TO_REGISTRY,
    HIDE_PRODUCT_REGISTRIES,
    HIDE_REGISTRIES_FROM_WISHLIST,
    RESET_ADD_TO_REGISTRY,
    SET_PRODUCT_REGISTRY_VERSION,
    SHOW_PRODUCT_REGISTRIES
};
